var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CButton',{attrs:{"color":"primary","shape":"pill","variant":"outline"},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v(" Back")])}
var staticRenderFns = []

export { render, staticRenderFns }